import { Attachment } from "types/common.types";

import { UploadedFile } from "components/Common/FileUploader";

import { UserSubscriptionStatus } from "store/auth/types";

export const bytesToSize = (bytes: number): string => {
  const sizes: string[] = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "n/a";
  const i: number = parseInt(
    Math.floor(Math.log(bytes) / Math.log(1024)).toString()
  );
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
};

export const getFileExtension = (filename: string) => {
  return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
};

export const blobDownload = (file: File) => {
  const url = window.URL.createObjectURL(file);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = file.name;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};

export const donwloadByUrl = (url: string) => {
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};

export const converBlobToUploadedFile = (
  blobPart: BlobPart[],
  attachment: Attachment
): UploadedFile => {
  const description = attachment.custom_properties.description;
  const fileName = attachment.file_name;
  const uuid = attachment.uuid;
  const file = new File(blobPart, fileName);
  return { file, description, uuid };
};

export const remapAttachmentObjectToList = (
  obj: Record<string, Attachment>
) => {
  const result: Attachment[] = [];
  const keys = obj && Object?.keys(obj);
  keys?.forEach((key) => result.push(obj[key]));
  return result;
};

export const toFormData = (data: Record<string, any>) => {
  const formdata = new FormData();
  Object.keys(data).forEach((key: string) => formdata.append(key, data[key]));

  return formdata;
};

export const removeDuplicatesOnUpload = (newUploadedFiles: UploadedFile[]) => {
  // create an empty set for keeping track of file names
  const fileNames = new Set<string>();

  // iterate through new files and add them to the list if the filename doesn't exist already
  const filteredFiles = newUploadedFiles.filter((file) => {
    const fileName = file.file.name;
    if (!fileNames.has(fileName)) {
      fileNames.add(fileName);
      return true;
    }
    return false;
  });

  return filteredFiles;
};
export const findPlan = (
  userRole?: string,
  subscription?: UserSubscriptionStatus
) => {
  // ✅ اقرأ من plan_code (مش plan)
  const planCode = subscription?.plan_code || subscription?.plan;

  // لو plan = mahdar-max → thirdPlan
  if (planCode === "mahdar-max") {
    return "thirdPlan";
  }

  // لو plan = mahdar-pro → secondPlan
  if (planCode === "mahdar-pro") {
    return "secondPlan";
  }

  // لو plan = mahdar-plus → firstPlan
  if (planCode === "mahdar-plus") {
    return "firstPlan";
  }

  // لو plan = free-plan → inTrail
  if (planCode === "free-plan") {
    return "inTrail";
  }

  // باقي الكود (لو في subscriptions array)
  const firstPlan = subscription?.subscriptions?.find(
    (sub) =>
      sub.plan.planCode === "mahdar-plus" &&
      (sub.status === "InTrial" || sub.status === "Active")
  );
  const secondPlan = subscription?.subscriptions?.find(
    (sub) => sub.plan.planCode === "mahdar-pro" && sub.status === "Active"
  );
  const thirdPlan = subscription?.subscriptions?.find(
    (sub) => sub.plan.planCode === "mahdar-max" && sub.status === "Active"
  );

  if (thirdPlan) return "thirdPlan";
  else if (secondPlan) return "secondPlan";
  else if (firstPlan) return "firstPlan";
  else return "inTrail";
};
